// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__19MPB","question":"Question_question__3EVPI","description":"Question_description__199l0"};